"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSkipLinkMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _VisuallyHiddenMixin = require("./VisuallyHiddenMixin");
/** @class CarouselSkipLinkMixin */
/** @method */
var CarouselSkipLinkMixin = function CarouselSkipLinkMixin(props) {
  return (0, _styledToken.default)({
    height: 'CarouselSkipLink.height',
    background: 'CarouselSkipLink.background',
    margin: 'CarouselSkipLink.margin',
    width: 'CarouselSkipLink.width'
  }, function (_ref) {
    var height = _ref.height,
      background = _ref.background,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
    return (0, _styledComponents.css)(["", " &:focus{background-color:", ";display:block;line-height:", "px;text-align:center;clip:auto;clip-path:none;height:", "px;margin:", "px;overflow:visible;position:absolute;width:", ";z-index:10;}"], _VisuallyHiddenMixin.VisuallyHiddenMixin, background, height, height, margin, width);
  })(props);
};
exports.CarouselSkipLinkMixin = CarouselSkipLinkMixin;